/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-null/no-null */
import { Chip, Input, ChipProps } from '@mui/material';
import { useState, forwardRef, useCallback, useRef } from 'react';

import { SearchBoxAutocompleteValue } from './search-box-types';
interface SearchBoxTextSegmentProps {
    option: string;
    onEdit: (index: number, newValue?: SearchBoxAutocompleteValue) => void;
    index: number;
    onDelete: (event: any) => void;
    className: string;
    searchBoxName: string;
}

export const SearchBoxTextSegment = forwardRef<HTMLDivElement, SearchBoxTextSegmentProps>(
    ({ option, onEdit, index, className, searchBoxName }, ref) => {
        const inputRef = useRef<HTMLInputElement>(null!);
        const handleRemove = useCallback<NonNullable<ChipProps['onDelete']>>(() => {
            const focusedInput = document.querySelector(
                `.search-box-${searchBoxName} [data-input="text-segment"] input`,
            );
            if (focusedInput) {
                (focusedInput as HTMLInputElement).blur();
            }
            onEdit(index, {
                optionName: searchBoxName,
                optionRelation: 'freeSolo',
                optionValue: '',
            });
        }, [index, onEdit, searchBoxName]);
        const [focused, setFocused] = useState(false);

        const handleInputUpdate = (): void => {
            onEdit(index, {
                optionName: searchBoxName,
                optionRelation: 'freeSolo',
                optionValue: inputRef.current.value,
            });
            setFocused(false);
        };

        return focused ? (
            <Input
                inputRef={inputRef}
                data-input='text-segment'
                autoFocus
                defaultValue={option}
                onKeyDown={(event) => {
                    if ('Enter' === event.key || 'Tab' === event.key) {
                        handleInputUpdate();
                    }
                    if (
                        ('ArrowLeft' === event.key && 0 === event.currentTarget.selectionStart) ||
                        ('ArrowRight' === event.key &&
                            event.currentTarget.value.length === event.currentTarget.selectionEnd)
                    ) {
                        /* empty */
                    } else {
                        event.stopPropagation();
                    }
                }}
                onBlur={() => {
                    handleInputUpdate();
                }}
            />
        ) : (
            <Chip
                tabIndex={-1}
                {...{ 'data-tag-index': index }}
                className={className}
                label={option}
                size='medium'
                ref={ref}
                onDelete={handleRemove}
                onFocus={() => {
                    setFocused(true);
                }}
                onClick={() => {
                    setFocused(true);
                }}
            />
        );
    },
);
